import BookForm from "components/shared/book/form";
import React from "react";
import { config, initialState } from "../formConfig";
import Markup from "./markup";

class FormTransportColumns extends BookForm {
    renderBody = () => {
        const { config } = this.props;
        return <Markup {...config} renderField={this.renderField} />;
    };
}

const ConfiguredForm = (props) => <FormTransportColumns {...props} config={config} initialState={initialState} />;

export default ConfiguredForm;
